import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants';
import { getData } from '../utils/api';
import API_ROUTES from '../constants/apiRoutes';

type UseMarketsCountOptions = {
  eventId: string;
  marketTypeGroupId?: string | false;
  search?: string;
  enabled?: boolean;
};

const useMarketsCount = ({ eventId, marketTypeGroupId, search, enabled = true }: UseMarketsCountOptions) => {
  return useQuery({
    queryKey: [QUERY_KEYS.markets, 'count', eventId, marketTypeGroupId, search],
    queryFn: (): Promise<number> =>
      getData(API_ROUTES.MARKET_COUNT, {
        eventId,
        marketTypeGroupId: marketTypeGroupId && marketTypeGroupId !== 'all' ? marketTypeGroupId : undefined,
        search: search?.trim() || undefined,
      }),
    enabled: enabled && !!eventId,
  });
};

export default useMarketsCount;
